import Http from "../http";

export default { 
  //查询用户自定义工具接口
  getUserTools(urlParams, params, callback) {
    Http.post(Http.hostName + "/xmh/lucky/tools/getUserTools", urlParams, params, (res) => {
      callback(res);
    });
  },
  //查询全部工具接口
  getAllToolsList(urlParams, params, callback) {
    Http.post(Http.hostName + "/xmh/lucky/tools/getAllToolsList", urlParams, params, (res) => {
      callback(res);
    });
  },
  //编辑用户自定义工具接口
  exitUserTools(urlParams,params, callback) {
    Http.post(Http.hostName + "/xmh/lucky/tools/exitUserTools", urlParams,params, (res) => {
      callback(res);
    });
  },
};
